import { FC } from 'react';
import { Image, Spacer } from '@chakra-ui/react';

import { TransactionFeeType } from '__generated__/GQL';
import boltImg from 'assets/brand/bolt@2x.png';
import { getFixedFeeForType } from 'common/fees';
import Button from 'components/_core/Button';
import Callout from 'components/_core/Callout';
import Heading from 'components/_core/Heading';
import Text from 'components/_core/Text';

import SidebarFooter from '../../../components/SidebarFooter';
import NavigationHeader from '../../NavigationHeader';
import locales from './locales';

const PRICING_PAGE_URL = 'https://www.shine.fr/tarifs/';
interface UpdatePinIntroProps {
  creditCardId: string;
  onNext: () => void;
}

const UpdatePinIntro: FC<UpdatePinIntroProps> = ({ creditCardId, onNext }) => {
  const priceWarning = locales.formatString(
    locales.warning,
    getFixedFeeForType(TransactionFeeType.CardAtmEuro),
  ) as string;

  return (
    <>
      <NavigationHeader backTo={`/cards/${creditCardId}`} />

      <Image
        alt=""
        boxSize="90px"
        marginBottom="space-32"
        role="presentation"
        src={boltImg}
      />

      <Heading marginBottom="space-8">{locales.title}</Heading>

      <Text marginBottom="space-24">{locales.description}</Text>

      <Callout>
        <Callout.Content>{priceWarning}</Callout.Content>
        <Callout.Button as="a" href={PRICING_PAGE_URL} target="_blank">
          {locales.help}
        </Callout.Button>
      </Callout>

      <Spacer />

      <SidebarFooter>
        <Button onClick={onNext} width="100%">
          {locales.cta}
        </Button>
      </SidebarFooter>
    </>
  );
};

export default UpdatePinIntro;
